import { GatsbyLinkProps, Link } from "gatsby";
import { AnchorHTMLAttributes, forwardRef } from "react";

import { ThemeUIStyleObject } from "@theme/components/ThemeUi";

import * as linkVariants from "../../themes/ms5/variants/links";

export interface MsLinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement>,
    GatsbyLinkProps<HTMLLinkElement> {
  variant?: keyof typeof linkVariants;
  /** Theme UI JSX pragma */
  sx?: ThemeUIStyleObject;
  className?: string;
}

/**
 * MsLink
 *
 * Note this component is shadowed in gatsby-site to add
 * ability to use gatsby-plugin-react-i18next
 *
 * Any changes should also be added to gatsby-site version
 */
export const MsLink = forwardRef<HTMLAnchorElement, MsLinkProps>(function MsLink(
  { children, to, sx, className, variant, ...rest },
  ref,
) {
  // Must add variant via sx prop since its not a theme-ui link
  const themeUiVariant = variant
    ? variant.startsWith("links.")
      ? variant
      : `links.${variant}`
    : "links.link";

  return (
    <Link
      to={to}
      // Not sure why this is reporting an error when the types look correct and work
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ref={ref}
      sx={{ variant: themeUiVariant, ...sx }}
      className={className}
      {...(rest as AnchorHTMLAttributes<HTMLAnchorElement>)}
    >
      {children}
    </Link>
  );
});
